import { Reveal } from "@/components/Reveal";

const ASEGURADORAS = [
  { nombre: "AXA", logo: "/assets/logos/axa.png" },
  { nombre: "Mapfre", logo: "/assets/logos/mapfre.webp" },
  { nombre: "GNP", logo: "/assets/logos/gnp.webp" },
  { nombre: "Seguros Latino", logo: "/assets/logos/seguros-latino.png" },
  { nombre: "El Águila", logo: "/assets/logos/el-aguila.png" },
];

export const Aseguradoras = () => (
  <section id="aseguradoras" data-testid="aseguradoras-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-[#1BA8E0]">
          Aseguradoras
        </p>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-[#0C5F8A] sm:text-3xl lg:text-4xl">
          Trabajamos con las aseguradoras más sólidas de México
        </h2>
        <p className="mt-4 text-base leading-relaxed text-[#2E3338]/75 sm:text-lg">
          No dependemos de una sola compañía. Eso nos permite comparar coberturas y precios, y recomendarte
          la opción que de verdad te conviene.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
        {ASEGURADORAS.map((a, i) => (
          <Reveal key={a.nombre} delay={i * 0.08} className={i === ASEGURADORAS.length - 1 ? "col-span-2 sm:col-span-1" : ""}>
            <div
              data-testid={`aseguradora-card-${a.nombre.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex h-32 items-center justify-center rounded-2xl border border-[#1BA8E0]/15 bg-white p-6 shadow-[0_10px_30px_-5px_rgba(12,95,138,0.08)] transition-all duration-500 hover:-translate-y-1.5 hover:border-[#F5B21B]/60 hover:shadow-[0_20px_40px_-12px_rgba(12,95,138,0.22)]"
            >
              <img
                src={a.logo}
                alt={`Logo de ${a.nombre}`}
                loading="lazy"
                className="max-h-full w-auto max-w-full object-contain transition-transform duration-500 hover:scale-105"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
